var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHockeyPuck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 64C128.588 64 0 96.273 0 177.848V315.078C0 402.309 128.705 448 256 448S512 402.309 512 315.078V184C512 102.426 383.412 64 256 64ZM464 315.078C464 361.109 368.748 400 256 400S48 361.109 48 315.078V258.926C87.561 285.035 153.838 304 256 304S424.439 285.035 464 258.926V315.078ZM256 256C141.09 256 48 223.824 48 184C48 150.121 131.58 112 256 112S464 150.121 464 184C464 223.824 370.91 256 256 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockeyPuck);
export default __webpack_public_path__ + "static/media/hockey-puck.f607bb3c070685a846569d0825e09335.svg";
export { ForwardRef as ReactComponent };